module.exports = __webpack_public_path__ + "img/Solutions-Catalog-650x340.b3ae39b6.png";